import { ReactNode } from 'react'
import { Box, Flex, Image } from '@chakra-ui/react'
import RallyBg from 'assets/images/rally-bg.png'
import { AUTH_MOBILE_BG, AUTH_MOBILE_TOP_OFFSET, DARK_SURFACE_GRADIENT } from './constants'

interface AuthLayoutProps {
  children: ReactNode
}

// Hero panel fill, straight from the design export. The gradient itself is dark
// navy; `hard-light` against the near-white backdrop is what lifts it to the
// bright blue of the design — roughly doubling each channel, so #1E3A5F paints
// as #2574BE. Dropping either the backdrop or the blend mode collapses the
// panel back to flat navy.
const HERO_PANEL_FILL = {
  backgroundColor: '#9DFFFF',
  backgroundImage:
    'linear-gradient(135deg, #1E3A5F 0%, #1D375B 7.14%, #1C3557 14.29%, #1B3560 50%, #10192E 92.86%, #0F172A 100%)',
  backgroundBlendMode: 'hard-light'
} as const

const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    // The global theme paints html/body white, so the root carries the dark fill
    // itself — otherwise any auth page taller than the viewport shows a white
    // block beside the form once it scrolls past the hero's 100vh.
    <Flex minH="100vh" w="100vw" bg={AUTH_MOBILE_BG}>
      {/* Left panel — phone hero. Hidden on mobile (< LG). Sticky so the art
          stays parked while a long form scrolls next to it. */}
      <Box
        display={{ base: 'none', lg: 'block' }}
        w="50%"
        flexShrink={0}
        h="100vh"
        position="sticky"
        top={0}
        alignSelf="flex-start"
        sx={HERO_PANEL_FILL}
        overflow="hidden"
      >
        <Image
          src={RallyBg}
          alt="Rally app preview"
          position="absolute"
          bottom={0}
          left="50%"
          transform="translateX(-50%)"
          h="66%"
          objectFit="contain"
          objectPosition="bottom center"
        />
      </Box>

      {/* Right panel — the form column. Dark on every breakpoint; desktop adds
          the raised surface gradient from the design, mobile stays flat so the
          page reads as a single dark sheet. */}
      <Flex
        flex={1}
        align={{ base: 'flex-start', lg: 'center' }}
        justify="center"
        bg={{ base: AUTH_MOBILE_BG, lg: DARK_SURFACE_GRADIENT }}
        minH="100vh"
        px={6}
        pt={{ base: AUTH_MOBILE_TOP_OFFSET, lg: 0 }}
      >
        {children}
      </Flex>
    </Flex>
  )
}

export default AuthLayout
